import { HOME_BY_ROLE } from './route-registry'
import { mapUserRoleToRouteRole } from './can-access-route'
import type { HomeRouteInput, RouteRole } from './types'

/**
 * Resolve the post-login / post-auth home route for the current user.
 * Uses effectiveRole when provided (respects admin QA perspective).
 */
export function resolveHomeRoute(input: HomeRouteInput = {}): string {
  if (input.isAnonymous) {
    return '/auth/try'
  }

  const role: RouteRole = input.effectiveRole ?? mapUserRoleToRouteRole(input.role)

  return HOME_BY_ROLE[role] ?? HOME_BY_ROLE.individual
}
